import React, { useContext, useEffect, useRef, useState } from 'react'
import { ButtonHeading, CommonInput, CommonModal, CustomPagination } from 'components'
import { deleteConsignorData } from '_services/accountsServices/consignorServices';
import StorageService from "utils/StorageServices/StorageServices";
import toast from 'react-hot-toast';
import { Link, useParams } from 'react-router-dom';
import { IoChevronBack, IoChevronForward } from "react-icons/io5";
import { deleteZoneData, getZoneListData } from '_services/accountsServices/zoneServices';

import BootstrapTable from 'components/BootstrapTable';
import { BsThreeDotsVertical } from "react-icons/bs";
import { AiOutlineEye } from "react-icons/ai";
import { FiEdit } from "react-icons/fi";
import { FaRegTrashCan } from "react-icons/fa6";
import MastersFilterModal from 'modals/MastersFilterModal';
import { constant } from 'constants/constant';
import { deleteVehicleGroupData, getVehicleGroupListData } from '_services/accountsServices/vehicleGroupServices';
import { UserContext } from 'context';
import useDocumentTitle from 'hooks/useDocumentTitle';
import AddEditVehicleDocTypeModel from 'modals/AddEditVehicleDocTypeModel/AddEditVehicleDocTypeModel';
import { deleteVehicleDocData, getVehicleDocTypeListData } from '_services/accountsServices/vehicleDocTypeServices';
import { CiLock, CiUnlock } from 'react-icons/ci';
import { deleteStore, getStoreList } from '_services/workShopServices/workShopServices';
import AddEditStoreModel from 'modals/AddEditStoreModel';
import { deleteFirmBank, getFirmBanksList, statusChangeFirmBank, updateFirmBank } from '_services/accountsServices/firmServices';
import { utils } from 'helper';
import AddEditFirmBankModel from 'modals/AddEditFirmBankModel/AddEditFirmBankModel';
import { AddBankAccount } from 'modals';
import { deleteBank, getBanksList } from '_services/accountsServices/mastersBankServices';

const BankSection = ({ type }) => {
    useDocumentTitle("Bank Firm Details | T360");

    let { id } = useParams();
    const { settingChild } = useContext(UserContext);
    const [bankModelData, setBankModelData] = useState(false);
    const [bankDataList, setBankDataList] = useState([])
    const [loading, setLoading] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const prevFilterRef = useRef();
    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    const getDataBankList = async () => {
        try {
            let object = {
                ...filter,
                company_id: StorageService.getCompanyId(),
                vendor_type: type,
                vendor_id: id,
            }
            delete object.limit;
            delete object.offset;
            const res = await getBanksList(object);
            if (res?.responseCode == 200) {
                setBankDataList(res?.data?.bank_account);
                setTotalItems(res?.data?.total_record);
            }
        } catch (error) {
        }
    }

    // useEffect(() => {
    //     const prevFilter = prevFilterRef.current;
    //     if (
    //         JSON.stringify(prevFilter) !== JSON.stringify(filter)
    //     ) {
    //         getDataBankList();
    //         prevFilterRef.current = filter;
    //     }
    // }, [filter, bankModelData])

    useEffect(() => {
        getDataBankList();
    }, [filter, id])

    const deleteHandler = (item) => {
        setIsDelete(item)
    }

    const submitDeleteBank = async () => {
        setLoading(true);
        try {
            let object = {
                company_id: StorageService.getCompanyId(),
                vendor_type: type,
                vendor_id: id,
                account_id: isDelete?._id,
            }
            const res = await deleteBank(object);
            if (res?.responseCode == 200) {
                toast.success(`${res?.responseMessage}`);
                getDataBankList();
                setLoading(false);
                setIsDelete(false);
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        }
    }

    let propsObject = {
        isOpen: isDelete,
        closeModal: setIsDelete,
        modalTitle: "Confirmation",
        submitTitle: "Confirm",
        cancleTitle: "Close",
        onSubmit: submitDeleteBank,
        isLoadding: loading,
    }

    const columns = [
        { header: "Account Number/UPI", accessor: "account_number" },
        { header: "Bank Name", accessor: "bank_name" },
        { header: "IFSC Code", accessor: "ifsc_code" },
        { header: "Branch Name", accessor: "branch_name" },
        { header: "Bank Code", accessor: "branch_code" },
        { header: "Account Holder Name", accessor: "name" },
        { header: "Address", accessor: "address" },
        { header: "Actions", accessor: "action" }
    ];

    const rowListData = (data) => {
        return data?.map((item, i) => ({
            ...item,
            account_number: <span className='_tblText _style_ancer' onClick={(e) => setBankModelData({ ...item, isDetails: true })}>
                <a className='_avPointer'>
                    {item?.account_number ? item?.account_number : item?.upi_id} &nbsp;
                </a>
            </span>,
            bank_name: <>{item?.bank_name ? item?.bank_name : '-'}</>,
            ifsc_code: <>{item?.ifsc_code ? item?.ifsc_code : '-'}</>,
            branch_name: <>{item?.branch_name ? item?.branch_name : '-'}</>,
            branch_code: <>{item?.branch_code ? item?.branch_code : '-'}</>,
            name: <>{item?.account_name ? item?.account_name : ''}</>,
            address: <>{(item?.city_name && item?.state_name) ? `${item?.city_name} , ${item?.state_name}` : (item?.city_name ? item?.city_name : item?.state_name)}</>,
            action: (
                <div
                    className="_anvSwitcherNew form-check form-switch"
                    style={{ width: "100px" }}
                >
                    <span className='_samAnchor' onClick={(e) => setBankModelData({ ...item, isDetails: true })}>
                        <span className='viewIcon_avt'>
                            <AiOutlineEye color="green" />
                        </span>
                    </span>

                    <div
                        onClick={(e) => setBankModelData({ ...item, isEdit: true, isDetails: false })}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='editIcon_avt'>
                                <FiEdit color="blue" />
                            </span>

                        </span>
                    </div>

                    <div
                        onClick={(e) => deleteHandler(item)}
                        className='_avPointer'
                    >
                        <span className='_samAnchor'>
                            <span className='deleteIcon_avt'>
                                <FaRegTrashCan color='red' />
                            </span>
                        </span>
                    </div>
                </div>
            ),
        }));
    };

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
    };

    const callBackAddAccount = () => {
        getDataBankList();
    }

    let firstAddBank = {
        isOpen: bankModelData,
        closeModal: (e) => setBankModelData(false),
        headerPart: false,
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Add Bank Account",
        submitTitle: "Continue",
        callBackAddAccount: callBackAddAccount,
        venderDetails: { vender_type: type, vender_id: id }
    };

    return (
        <div className="__profilCmp_main">
            <div className='pd_manufr'>
                <div className='__filtsTb_flexMain _dix_jstBtwn'>
                    <div className='__filtsTb_flex'>
                        <div className='__fInx_bx'>
                            <CommonInput
                                type="search"
                                label='Search'
                                placeholder='Search'
                                name='search'
                                value={filter.search}
                                maxLength="30"
                                onInput={utils.maxLengthCheck}
                                onChange={(e) => setFilter((s) => ({ ...s, search: e.target.value }))}
                            />
                        </div>
                        {(filter.search) &&
                            <div>
                                <button
                                    className='manuRsret'
                                    onClick={() => setFilter((s) => ({ ...s, search: '' }))}
                                >
                                    Clear
                                </button>
                            </div>}
                    </div>
                    <button className="anime-btn _addComm_btn _tnx_firmBxn" onClick={() => setBankModelData(true)}>
                        + Add Bank
                    </button>
                </div>
            </div>

            <div className='_tabWith_outTab'>
                <BootstrapTable
                    columns={columns}
                    data={rowListData(bankDataList?.length > 0 ? bankDataList : [])}
                    isLoading={loading}
                />

                {(totalItems > 0 && bankDataList?.length) ? <div className='paginationFt_avt'>
                    <CustomPagination
                        totalItems={totalItems}
                        itemsPerPage={itemsPerPage}
                        currentPage={filter.offset}
                        onPageChange={handlePageChange}
                    />
                </div> : <></>}
            </div>

            {bankModelData && <AddBankAccount {...firstAddBank} />}

            {
                isDelete?._id && (
                    <CommonModal {...propsObject}>
                        <p className='p-3'> Are you sure you want to delete {isDelete?.name} ?</p>
                    </CommonModal>
                )
            }
        </div>
    )
}

export default BankSection